module.exports = __webpack_public_path__ + "img/4. observation_4.5602a9ee.jpg";